import React, { useState, useRef, useEffect } from "react";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";
import { getSentenceCase } from "../../utils/utilityFunctions/stringUtility";
import useClickOutside from "../../hooks/Screen/useClickOutside";
const AdvancedInputComponent = ({
  type = "text",
  value = "",
  onChange,
  name = "",
  onBlur,
  className = "flex-col",
  placeholder = "",
  label = "",
  helperText,
  id,
  autoFocus = false,
  mandatory = false,
  height = "2.6rem",
  icon,
  clickFocus = false,
  checked,
  inputClassName,
  labelClassName = "text-sm font-medium text-gray-700 mb-2",
  isDisabled = false,
  ...props
}) => {
  const [touched, setTouched] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isInputFocused, setIsInputFocused] = useState(false);
  const inputRef = useRef(null); // Reference to the input field

  const handleInputBlur = () => {
    setIsInputFocused(false);
    setTouched(true);
    if (mandatory && !value && value !== 0) {
      setErrorText(helperText ?? `Enter ${getSentenceCase(name)}`);
    } else if (type === "email" && value && !isValidEmail(value)) {
      setErrorText("Enter a valid email address");
    } else if (type === "number" && value && !isValidNumber(value)) {
      setErrorText("Enter a valid number");
    } else if (type === "text" && value && !isValidName(value)) {
      setErrorText("Enter a valid name");
    } else if (type === "amount" && value && !isValidAmount(value)) {
      setErrorText("Enter a valid amount");
    } else {
      setErrorText(""); // Clear the error if valid
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    console.log("emailRegex.test(email)", emailRegex);
    return emailRegex.test(email);
  };

  const isValidNumber = (number) => {
    const numberRegex = /^[0-9]+$/;
    return numberRegex.test(number);
  };

  const isValidName = (name) => {
    // Allow letters, spaces, and dashes (for hyphenated names)
    const nameRegex = /^[a-zA-Z\s\-]+$/;
    return nameRegex.test(name);
  };

  const isValidAmount = (amount) => {
    // Match numbers and allow decimals (e.g., 123, 123.45)
    const amountRegex = /^\d+(\.\d{1,2})?$/;
    return amountRegex.test(amount);
  };

  const handleInputChange = (event) => {
    setTouched(true);
    onChange(event);
  };

  const hasError = mandatory && ((touched && !value) || errorText);
  return (
    <div className={`flex  ${className} w-full`} role="form">
      {label && (
        <label htmlFor={id} className={labelClassName} aria-label={label}>
          {label}
        </label>
      )}
      <div className="w-full h-full ">
        <div
          className={`w-full flex  items-center border rounded-md text-sm border-b-2 px-2 h-[${height}] ${
            hasError ? "border-b-2 border-b-[#EF4444]" : isInputFocused ? ` border-[#7A7D84] ` : ` border-[#DFE2E5]`
          } ${isDisabled ? "opacity-50 cursor-not-allowed border-DFE2E5 bg-[#EDEDED] text-[#868686]" : "border-DFE2E5 bg-white text-434852"} ${inputClassName}`}
        >
          <input
            ref={inputRef} // Attach the ref to the input field
            name={name}
            type={type}
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            // className={`px-3 py-2 border rounded-md text-sm h-[${height}] ${
            //   mandatory && ((touched && !value) || errorText) && !value
            //     ? "border-red-500 focus:ring-red-500 focus:border-red-500"
            //     : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            // }`}
            className={`grow min-w-0 px-0 pr-2 py-2 rounded-md text-sm h-full w-full focus:ring-0 ring-0 border-0 bg-inherit text-[#292E33] placeholder:text-[#AFAFAF]  ${inputClassName ?? ""}`}
            id={id}
            aria-invalid={errorText ? "true" : "false"}
            aria-describedby={hasError ? `${id}-helper` : undefined}
            {...props}
            onBlur={() => {
              //   if (!icon) {
              //     setIsInputFocused(false);
              //     onBlur ? onBlur() : handleInputBlur();
              //   }
              handleInputBlur();
            }}
            tabIndex={0} // Ensures the input is part of the tab order
            autoFocus={autoFocus} // Focus the input field on page load if required
            onFocus={() => {
              setIsInputFocused(true);
            }}
            disabled={isDisabled} // Disable the input if required
          />
          {icon && icon}
        </div>
        {hasError && (
          <span
            id={`${id}-helper`}
            className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px] mt-2"
            role="alert"
            aria-live="assertive"
          >
            <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
            {errorText || "Enter Value"}
          </span>
        )}
      </div>
    </div>
  );
};

export default AdvancedInputComponent;
